import { api } from '@/shared/lib/api'
import { useMutation } from '@tanstack/react-query'
import type { SearchHistoryItem } from '@workspace/lib/api'

export const useSaveSearchHistory = () => {
    return useMutation({
        mutationFn: async (data: SearchHistoryItem) => {
            await api.searchGlobal.saveHistory(data)
        },
        meta: {
            invalidates: [['search-histories']],
        },
    })
}
